module.exports = {

  maintenance_warnings_tab_title: "Maintenance Warnings",
  maintenance_warnings_tab_filter_by_last: "Last",
  maintenance_warnings_tab_filter_by_date: "Range",
  maintenance_warnings_tab_apply_filters: "Apply",
  
  maintenance_warnings_tab_date_range: "Please select a valid date range",
  maintenance_warnings_tab_raw_message: "Raw Message",

  maintenance_warnings_tab_warning: "Warning",
  maintenance_warnings_tab_warning_time: "Warning Time",
  maintenance_warnings_tab_value: "Value",
  maintenance_warnings_tab_details: "Details",
  maintenance_warnings_tab_no_warnings: "There is no warnings",
  maintenance_warnings_tab_sd_card_status: "SD Card Status is",
  maintenance_warnings_tab_last_status: "Last Status",


  maintenance_warnings_tab_resolve_all: "Resolve All",
  maintenance_warnings_tab_clear_all: "Clear All",
  maintenance_warnings_tab_search_by_warning: "Search by Warning",
  maintenance_warnings_tab_resolve_issue: "Resolve Issue",
  maintenance_warnings_tab_clear: "Clear",
  maintenance_warnings_tab_first_occurrence: "First Occurrence",
  maintenance_warnings_tab_last_occurrence: "Last Occurrence",
  maintenance_warnings_tab_warnings: "Occurrences",

  maintenance_warnings_tab_issues: "Issues",
  maintenance_warnings_tab_resolved: "Resolved",

  maintenance_warnings_tab_default_message: "The description for this warning is coming soon!!!",
  maintenance_warnings_tab_back_to_issues: "Back to Issues",
  maintenance_warnings_tab_resolve: "Resolve",



  maintenance_warnings_tab_AuxCamDisconnected: "Aux Camera Disconnected",
  maintenance_warnings_tab_BatteryVoltageLow: "Battery Voltage Low",
  maintenance_warnings_tab_CameraDisconnectedFromServerOver7Days: "Camera Disconnected From Server Over 7 Days",
  maintenance_warnings_tab_CameraTilted: "Camera Tilted - Check Orientation",
  maintenance_warnings_tab_dmsStatusChange: "DMS Status Change",
  maintenance_warnings_tab_DrivingOver18Hours: "Driving Over 18 Hours",
  maintenance_warnings_tab_FailedToEnterStandby: "Failed To Enter Standby",
  maintenance_warnings_tab_FormatSDCard: "Format SD Card",
  maintenance_warnings_tab_GPSGapTooLarge: "GPS Gap Too Large",
  maintenance_warnings_tab_LowVBUSVoltage: "Low VBUS Voltage",
  maintenance_warnings_tab_MCUDisconnected: "MCU Disconnected",
  maintenance_warnings_tab_ReplaceSDCard: "Replace SD Card",
  maintenance_warnings_tab_SDCardStatus: "SD Card Status",
  maintenance_warnings_tab_SIMCardInfoChanged: "SIM Card Info Changed",
  maintenance_warnings_tab_UnfavorableAngleOfRoadView: "Unfavorable Angle Of Road View",
  maintenance_warnings_tab_VinNumChanged: "Vin Num Changed",
  maintenance_warnings_tab_UnsupportedVideoConfigCombinations: "Unsupported Video Config Combinations",
  maintenance_warnings_tab_HDOPQuality: "HDOP Quality",
  maintenance_warnings_tab_ExcessiveEvents: "Excessive Events",
  maintenance_warnings_tab_LowBattery: "Low Battery",
  maintenance_warnings_tab_IgnitionOnEventsAbnormal: "Ignition On Events Abnormal",
  maintenance_warnings_tab_PowerDisconnect: "Power Disconnect",
  maintenance_warnings_tab_LowSatellites: "Low Satellites",
  maintenance_warnings_tab_DailyOdometerExceeded: "Daily Odometer Exceeded",
  maintenance_warnings_tab_WirelessSignal: "Wireless Signal",
  maintenance_warnings_tab_MaintenanceLimitExceeded: "Maintenance Limit Exceeded",
  maintenance_warnings_tab_LateEvents: "Late Events",
  maintenance_warnings_tab_CommLost: "Comm Lost",
  maintenance_warnings_tab_DailyEngineHoursExceeded: "Daily Engine Hours Exceeded",
  

  maintenance_warnings_tab_resolve_all_warnings: "Resolve all warnings",
  maintenance_warnings_tab_resolve_warning: "Resolve Warning",
  maintenance_warnings_tab_success_message_all: "The warnings have been resolved",
  maintenance_warnings_tab_success_message: "The warning has been resolved",
  maintenance_warnings_tab_error_message_all: "Warnings could not be resolved due to error",
  maintenance_warnings_tab_error_message: "Unable to resolve the warning due to an error",
  maintenance_warnings_tab_description_all: "Are you sure you want to resolve all warnings? This action cannot be undone.",
  maintenance_warnings_tab_description: "Are you sure you want to resolve the warning? This action cannot be undone.",
  maintenance_warnings_tab_delete_warnings: "Delete Warnings",
  maintenance_warnings_tab_delete_warning: "Delete Warning",
  maintenance_warnings_tab_success_message_delete_all: "Warnings have been deleted",
  maintenance_warnings_tab_success_message_delete: "The warning has been deleted",
  maintenance_warnings_tab_error_message_delete_all: "Warnings could not be deleted due to an error",
  maintenance_warnings_tab_error_message_delete: "Unable to delete the warning due to an error",
  maintenance_warnings_tab_description_delete_all: "Are you sure you want to delete all warnings? This action cannot be undone.",
  maintenance_warnings_tab_description_delete: "Are you sure you want to delete the warning? This action cannot be undone.",
  maintenance_warnings_tab_resolved_on: "Resolved On",
  maintenance_warnings_tab_resolved_by: "Resolved By",
}
